import { createContext, useContext } from 'react';

// Context for managing tours across the app
export const TourContext = createContext(null);

export const useTour = () => useContext(TourContext);
